import { render, staticRenderFns } from "./ResultDetail.vue?vue&type=template&id=228c6ca9&scoped=true"
import script from "./ResultDetail.vue?vue&type=script&lang=js"
export * from "./ResultDetail.vue?vue&type=script&lang=js"
import style0 from "./ResultDetail.vue?vue&type=style&index=0&id=228c6ca9&prod&lang=css"
import style1 from "./ResultDetail.vue?vue&type=style&index=1&id=228c6ca9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228c6ca9",
  null
  
)

export default component.exports